import React from 'react';

const Navbar=()=>{
    return(
        <>
            <nav className="nav">
                <h1 className="title">🎥 Movies World 🎥</h1>
            </nav>
        </>
    )
}

export default Navbar;